import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Contact() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-brand-dark rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row">
          
          {/* Info Side */}
          <div className="md:w-2/5 p-12 bg-gray-900 text-white relative overflow-hidden">
            <div className="absolute bottom-0 right-0 w-64 h-64 bg-teal-500/10 rounded-full blur-3xl"></div>
            <h3 className="text-3xl font-bold mb-8 relative z-10">{t('contact.info')}</h3>
            
            <div className="space-y-8 relative z-10">
              <div className="flex items-start gap-4">
                <SafeIcon icon={FiMail} className="text-2xl text-blue-400 mt-1" />
                <div>
                  <p className="text-sm text-gray-400 mb-1">{t('contact.email')}</p>
                  <p className="font-medium">hello@izziseoclone.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <SafeIcon icon={FiPhone} className="text-2xl text-blue-400 mt-1" />
                <div>
                  <p className="text-sm text-gray-400 mb-1">{t('contact.phone')}</p>
                  <p className="font-medium">+30 210 123 4567</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <SafeIcon icon={FiMapPin} className="text-2xl text-blue-400 mt-1" />
                <div>
                  <p className="text-sm text-gray-400 mb-1">{t('contact.location')}</p>
                  <p className="font-medium">Athens, Greece</p>
                </div>
              </div>
            </div>
          </div>

          {/* Form Side */}
          <div className="md:w-3/5 p-12 bg-white">
            <h3 className="text-3xl font-bold text-gray-900 mb-8">{t('contact.title')}</h3>
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('contact.name')}</label>
                  <input type="text" className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{t('contact.phone')}</label>
                  <input type="tel" className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t('contact.email')}</label>
                <input type="email" className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t('contact.message')}</label>
                <textarea rows="4" className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all resize-none"></textarea>
              </div>
              <button className="w-full bg-gradient-primary text-white font-bold py-4 rounded-lg hover:shadow-lg transition-all transform hover:-translate-y-0.5">
                {t('contact.send')}
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
}